export const permissionsFields = {
    name: 'name',
} as const;
